import React from 'react';
import { formatDateToString } from '../utils/dateUtils';

interface EmptyStateProps {
  selectedDate: Date | null;
  onClearDate?: () => void;
  type: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ selectedDate, onClearDate, type }) => {
  return (
    <div className="rounded-lg border border-gray-800 bg-palette-black-4 p-8 text-center">
      <div className="text-gray-400 mb-2">
        {selectedDate
          ? `No ${type} found for ${formatDateToString(selectedDate)}.`
          : `No ${type} found for the selected timeframe and filters.`}
      </div>
      <div className="text-sm text-gray-500">Try adjusting your filters to see more results</div>
      {selectedDate && onClearDate && (
        <button
          onClick={onClearDate}
          className="mt-2 text-sm text-brand-primary hover:text-blue-400"
        >
          Clear date filter
        </button>
      )}
    </div>
  );
};